import React from 'react';
import { Analytics } from '@gik/core/utils';
import { Button, FontIcon, Heading, SvgIcon } from '@gik/ui';
import bemBlock from '@gik/core/utils/bemBlock';
import { inkindPageTourSelectors } from '@gik/inkind-page/components/InkindPageTour/InkindPageTour';
import { usePageGoFundMeCampaignValid } from '@gik/inkind-page/api/GoFundMeAPI';
import { useInkind } from '@gik/api/inkinds/inkind';

export interface IOtherWaysToSupportProps {
  inkindRouteId: string;
}

// TODO please remove inline styles (and fonticons if possible) upon migrating this to SPA
export default function OtherWaysToSupport({ inkindRouteId }: IOtherWaysToSupportProps) {
  const { data: inkindPage } = useInkind(inkindRouteId);
  const { data: isGoFundMeCampaignValidData } = usePageGoFundMeCampaignValid(inkindPage?.routeId);

  const bem = bemBlock('other-ways-to-support');
  const currencyCode = 'USD';

  const supportWithAmazonWishList = () =>
    inkindPage?.amazonWishlist && inkindPage?.amazonWishlistRequest?.amazonWishlistUrl_WithRef;
  const supportWithPayPal = () =>
    inkindPage?.payPal /* acceptsCrowdfunding */ && inkindPage?.financialContributions?.paypalEmail;
  const supportWithGoFundMe = () =>
    inkindPage?.payPal /* acceptsCrowdfunding */ &&
    inkindPage?.financialContributions?.goFundMeUrl &&
    isGoFundMeCampaignValidData?.valid;

  return supportWithAmazonWishList() || supportWithPayPal() || supportWithGoFundMe() ? (
    <div className={bem()}>
      <Heading level={3} variant={'default-light'} className={bem('title')}>
        Other Ways to Support
      </Heading>

      {supportWithAmazonWishList() && (
        <>
          <Button
            className={bem('amazon-wishlist')}
            variant={'amazon'}
            type={'a'}
            externalLink
            href={inkindPage?.amazonWishlistRequest.amazonWishlistUrl_WithRef}
            block
            prepend={
              <FontIcon
                style={{
                  fontSize: '1.25rem',
                }}
                name={'amazon'}
              />
            }
          >
            From Amazon Wishlist
          </Button>
          <p className={bem('disclaimer')}>InKind may earn a commission from purchases made through this button</p>
        </>
      )}
      <div id={inkindPageTourSelectors.donations}>
        {supportWithPayPal() && (
          <Button
            block
            variant={'paypal'}
            type={'a'}
            externalLink
            href={`https://www.paypal.com/cgi-bin/webscr?cmd=_donations&business=${inkindPage?.financialContributions.paypalEmail}&currency_code=${currencyCode}`}
            onClick={() => Analytics.fireDonateEvent('Paypal')}
            append={
              <SvgIcon
                style={{
                  width: '4rem',
                  marginBottom: '3px',
                }}
                name={'PayPal'}
                set={'brand-icons'}
              />
            }
          >
            Donate via
          </Button>
        )}
        {supportWithGoFundMe() && (
          <embed
            className={bem('gofundme-embed')}
            src={`https://www.gofundme.com/mvc.php?route=widgets/mediawidget&fund=${inkindPage?.financialContributions.goFundMeUrl}&image=0&coinfo=0&preview=0`}
            type="text/html"
            onClick={() => Analytics.fireDonateEvent('GoFundMe')}
          />
        )}
      </div>
    </div>
  ) : null;
}
